import React, { useEffect, useRef } from 'react';

const SoundWave = ({ 
  isActive = false, 
  barCount = 20, 
  height = '50px',
  color = '#CDFFF9',
  className = ''
}) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const bars = containerRef.current.querySelectorAll('.sound-bar');
    
    // Set random animation duration for each bar to create organic movement
    bars.forEach((bar) => {
      const randomDuration = Math.random() * (0.7 - 0.2) + 0.2; // 0.2s to 0.7s
      bar.style.animationDuration = `${randomDuration}s`;
    });
  }, [barCount]);

  return (
    <>
      <div 
        ref={containerRef}
        className={`flex items-center justify-center ${className}`}
        style={{ height }}
      >
        {Array.from({ length: barCount }, (_, i) => (
          <div
            key={i}
            className={`sound-bar ${
              isActive ? (
                i < 3 || i >= barCount - 3 
                  ? 'animate-wave-sm' 
                  : i < 7 || i >= barCount - 7 
                  ? 'animate-wave-md' 
                  : 'animate-wave-lg'
              ) : ''
            }`}
            style={{
              backgroundColor: color,
              margin: '0 1.5px',
              height: '10px',
              width: '1px',
            }}
          />
        ))}
      </div>
      
      <style jsx="true">{`
        .sound-bar {
          animation-iteration-count: infinite;
          animation-timing-function: ease-in-out;
          animation-direction: alternate;
        }
        
        @keyframes wave-sm {
          0% {
            opacity: 0.35;
            height: 10px;
          }
          100% {
            opacity: 1;
            height: 25px;
          }
        }
        
        @keyframes wave-md {
          0% {
            opacity: 0.35;
            height: 15px;
          }
          100% {
            opacity: 1;
            height: 50px;
          }
        }
        
        @keyframes wave-lg {
          0% {
            opacity: 0.35;
            height: 15px;
          }
          100% {
            opacity: 1;
            height: 70px;
          }
        }
        
        .animate-wave-sm {
          animation-name: wave-sm;
        }
        
        .animate-wave-md {
          animation-name: wave-md;
        }
        
        .animate-wave-lg {
          animation-name: wave-lg;
        }
      `}</style>
    </>
  );
};

export default SoundWave;
